export  class AwrDomainContext<T> {
    domain: string;
    value: T;
}

export  class AwrAccountContextValue {
    accountNumber: string;
    timPeriod: string;
    goToTab: string;
    awrAccount: String;
    constructor(accountNumber: string, timPeriod: string, goToTab: string, awrAccount: string) {
        this.accountNumber = accountNumber;
        this.timPeriod = timPeriod;
        this.goToTab = goToTab;
        this.awrAccount = awrAccount;
    }
}
